import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { NavigationModule } from "@lantern/app/common/navigation";
import { provideAppConfig } from "@lantern/app/core/app.config";
import { LanternCoreModule } from "@lantern/app/core/core.module";
import { LanternAppModule } from "@lantern/app/lantern-app.module";

import { appMenu } from "./app-menu";
import { AppComponent } from "./app.component";
import { LocalCommonModule } from "./common";
import { LocalCoreModule } from "./core";
import { PagesModule } from "./pages";
import { AppRoutingModule } from "./routing";

@NgModule({
  imports: [
    BrowserModule,

    LanternAppModule,
    LanternCoreModule,
    NavigationModule,

    LocalCommonModule,
    LocalCoreModule,

    AppRoutingModule,
    PagesModule
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    provideAppConfig({
      apiPath: "/global-auth",
      name: "GLOBAL_AUTH",
      displayName: "Tapad",
      menu: appMenu,
      auth: {
        martAuth: false
      },
      isGlobalApp: true
    })
  ]
})
export class AppModule {}
